
import { supabase } from "@/integrations/supabase/client";
import { Service } from "@/lib/data";

export async function getServiceById(serviceId: string): Promise<Service | null> {
  const { data, error } = await supabase
    .from('services')
    .select('*')
    .eq('service_id', serviceId)
    .single();
  
  if (error) {
    if (error.code === 'PGRST116') {
      return null;
    }
    console.error('Error fetching service:', error);
    throw error;
  }
  
  return {
    service_id: data.service_id,
    service_name: data.service_name,
    default_price: data.default_price,
    description: data.description || '',
    parent_service_id: data.parent_service_id
  };
}

export async function getServices(): Promise<Service[]> {
  const { data, error } = await supabase
    .from('services')
    .select('*')
    .order('service_name');
  
  if (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
  
  return data.map(service => ({
    service_id: service.service_id,
    service_name: service.service_name,
    default_price: service.default_price,
    description: service.description || '',
    parent_service_id: service.parent_service_id
  }));
}
